import { getVm } from '@/helpers/vm-helper';
import TitleDetailRedesign, { TitleDetailRedesignVariants, TitleDetailRedesignName } from './index';
import { ExperimentTrackEventOptions } from '@/components/experiments/Core/types';

export const trackTitleDetailRedesign = (
	TrackingOptions: ExperimentTrackEventOptions<TitleDetailRedesignVariants>,
	lastRoute = false
) => {
	const vm = getVm();
	const activeVariant =
		vm?.$store.getters['experiment/activeVariantsWithControlGroup'][TitleDetailRedesignName] ?? null;
	const isUserLoggedIN = vm?.$store.getters['user/isLoggedIn']() ?? false;
	const lastRouteName = vm?.$store.state.routing.lastRoute?.name;
	const isMoviePage = (lastRoute ? lastRouteName : vm?.$route.name) === 'app.detail.movies';
	if (activeVariant && !isUserLoggedIN && isMoviePage) {
		TitleDetailRedesign.trackEvent({ ...TrackingOptions, property: 'movie' });
	}
};
